import * as React from 'react';
import { getIntlString } from '@goparrot-dashboard/i18n';
import { AlertTriangle } from '@goparrot-dashboard/shared-ui';
import { FC } from 'react';

type Props = {
  pageName?: string;
};

export const InsufficientPermissions: FC<Props> = ({ pageName }) => {
  const heading = pageName ? getIntlString('permission.errorWithPageName', { pageName: getIntlString(pageName) }) : getIntlString('permission.error');

  return (
    <div
      className="
          tw-w-full tw-flex tw-justify-center tw-flex-col tw-items-center
          tw-py-10 tw-px-0 tw-flex-1 tw-gap-2 !tw-h-[calc(100vh-140px)] tw-min-h-[180px]
    "
    >
      <AlertTriangle className="tw-w-15 tw-h-15" />
      <h3 className="tw-text-center">{heading}</h3>
    </div>
  );
};
